import Course from "./Course";
import { ParticipantData } from "./Participant";

export enum InvitationStatus {
  PENDING = "pending",
  ACCEPTED = "accepted",
  EXPIRED = "expired",
  REVOKED = "revoked",
}

export interface Invitation {
  id: string;
  courseId: string;
  participant: ParticipantData;
  course: Course;
  status: InvitationStatus;
  invitationDate: string;
  invitationSentDate: string;
  expirationDate: string;
  isAccepted: boolean;
}
